import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: end;\n  margin-top: 28px;\n\n  > button {\n    font-size: 16px;\n    padding: 12px 20px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useRedirect, { REDIRECT_QUERY } from "@/hooks/useRedirect";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { LOGIN_PAGE, REGISTRATION_PAGE } from "@/settings/constant";
import { Button, ConfirmDialog } from "@bookips/solvook-ui-library";
import { useRouter } from "next/router";
import { useCallback } from "react";
import styled from "styled-components";
import LoginDialog from "../../store/loginDialog";
const CheckLoginDialog = (param)=>{
    let { open , onClose , onClickLogin , onClickSignUp  } = param;
    const router = useRouter();
    const { loginPath , redirectToLogin  } = useRedirect();
    const { closeLoginDialog  } = LoginDialog();
    const currentPathname = router.asPath;
    const redirectLoginPage = useCallback(()=>{
        // mx-9
        mixpanelEvent("Popup Button Clicked", {
            "Popup Type": "login",
            "Popup Title": "로그인이 필요해요",
            "Button Name": "로그인",
            "Button URL": LOGIN_PAGE
        });
        onClickLogin === null || onClickLogin === void 0 ? void 0 : onClickLogin(loginPath);
        closeLoginDialog();
        redirectToLogin();
    }, [
        router,
        loginPath
    ]);
    const redirectSignUpPage = useCallback(()=>{
        // mx-9
        mixpanelEvent("Popup Button Clicked", {
            "Popup Type": "signup",
            "Popup Title": "로그인이 필요해요",
            "Button Name": "회원가입",
            "Button URL": REGISTRATION_PAGE
        });
        const registrationPath = "".concat(REGISTRATION_PAGE, "?").concat(REDIRECT_QUERY, "=").concat(currentPathname);
        onClickSignUp === null || onClickSignUp === void 0 ? void 0 : onClickSignUp(registrationPath);
        closeLoginDialog();
        router.push(registrationPath);
    }, [
        router,
        currentPathname
    ]);
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        open: open,
        onClose: onClose,
        title: "로그인이 필요해요.",
        content: /*#__PURE__*/ _jsx("p", {
            children: "로그인 혹은 회원가입을 진행해주세요."
        }),
        footer: /*#__PURE__*/ _jsxs(ButtonBox, {
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    variant: "soft",
                    label: "로그인",
                    onClick: redirectLoginPage
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "solid",
                    label: "회원가입",
                    onClick: redirectSignUpPage
                })
            ]
        })
    });
};
const ButtonBox = styled.div.withConfig({
    componentId: "sc-71e6b03-0"
})(_templateObject());
export default CheckLoginDialog;
